const routes = {
  createBank: 'system/banks/add',
  updateBank: 'system/banks/update',
  getBanks: 'system/banks',
  getBanksWithOutToken: 'system/banksWithOutToken',
  updateBankStatus: 'system/banks/add',
  getExportBanks:'system/exportBanks'
};

export default routes